<template>
  <ProductSelector
    ref="productSelector"
    endpoint="products"
    :data="data"
    :errors="errors"
    dataKey="products"
    :packageType="packageType"
    :isMailboxSession="isMailboxSession"
    :flowType="flowType"
    :currentStep="currentStep"
    @update="onUpdate"
  />
</template>

<script>
import ProductSelector from '../templates/ProductSelector.vue';

export default {
  name: 'Products',
  components: { ProductSelector },
  props: {
    data: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    endpoint: { type: String, required: true },
    packageType: { type: String, default: 'large' },
    mode: { type: String, default: null },
    isMailboxSession: { type: Boolean, default: false },
    flowType: { type: String, default: 'compose' },
    currentStep: { type: Number, default: 0 },
  },
  emits: [
    'update',
    'next',
    'go-to-step',
    'reset-package',
    'start',
    'increase-product',
    'decrease-product',
    'add-to-cart',
    'remove-product',
    'remove-food',
    'remove-packaging',
    'select-base',
    'printing-updated',
    'remove-base-package',
  ],
  mounted() {
    this.setupEventListeners();
  },
  beforeUnmount() {
    this.removeEventListeners();
  },
  methods: {
    onUpdate(payload) {
      this.$emit('update', payload);
    },
    setupEventListeners() {
      this.reloadHandler = () => {
        if (this.$refs.productSelector) {
          this.$refs.productSelector.fetchProducts();
        }
      };
      document.addEventListener('s7_reload_products', this.reloadHandler);
    },
    removeEventListeners() {
      if (this.reloadHandler) {
        document.removeEventListener('s7_reload_products', this.reloadHandler);
      }
    },
  },
};
</script>
